import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/modules/shared/shared.module';

@Component({
  selector: 'app-user-login-loader',
  standalone: true,
  imports: [CommonModule,SharedModule],
  templateUrl: './user-login-loader.component.html',
  styleUrls: ['./user-login-loader.component.scss']
})
export class UserLoginLoaderComponent {}
